import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import FormMonitoring from "components/FormMonitoring";
import { Dashboard, StatsLabels } from "locale/es";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AppColors } from "resources/AppColors";
import { formatDateForRequests } from "utils/HelperFunctions";
import DatePickerMonitoring from "components/DatePickers/DatePickerMonitoring/DatePickerMonitoring";
import moment from "moment";
import PatientsService from "services/PatientsService";
import { format } from 'date-fns';
import SingleChoiceDropdown from "components/Dropdowns/SingleChoiceDropdown";
import Loader from "components/Loader/Loader";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: AppColors.PRIMARY,
      },
    },
    "& .MuiInputBase-root": {
      color: AppColors.PRIMARY,
    },
    "& .MuiInputLabel-root": {
      color: AppColors.PRIMARY,
    },
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
  },
}));

const dataTypeOptions = [
  { name: StatsLabels.STEPS, value: "STEPS" },
  { name: StatsLabels.CALORIES, value: "CALORIES" },
  { name: StatsLabels.HR, value: "HR" },
  { name: StatsLabels.WEIGHT, value: "WEIGHT" },
];

const ExportForm = ({ setShowModal }) => {
  const classes = useStyles();

  const patientData = useSelector(({ patient }) => patient);
  const patientId = patientData.id;
  const [initialDate, setInitialDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedTypeHealthData, setSelectedTypeHealthData] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false)

  const handleExportObservations = async (e) => {
    e.preventDefault();

    try {
      const startDate = initialDate
        ? formatDateForRequests(moment(initialDate))
        : "";
      const finalDate = endDate
        ? formatDateForRequests(moment(endDate).endOf("day"))
        : "";

      setLoading(true)

      const { data } = await PatientsService.exportObservations(
        selectedTypeHealthData,
        patientId,
        startDate,
        finalDate
      );

      setLoading(false)

      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${patientData.fullName}-${selectedTypeHealthData}-${format(new Date(), 'dd/MM/yyyy')}.csv`)
      document.body.appendChild(link)
      link.click()
      link.remove()

      setShowModal(false);
    } catch (error) {
      setLoading(false)
      setErrorMessage("Ha ocurrido un error durante la generación del archivo")
    }
  };

  const resetFormInputs = () => {
    setInitialDate(null);
    setEndDate(null);
    setSelectedTypeHealthData("");
  };

  const handleInitialDate = (dateObject) => {
    if (!!errorMessage) setErrorMessage("");
    setInitialDate(dateObject);
  };

  const handleEndDate = (dateObject) => {
    if (!!errorMessage) setErrorMessage("");
    setEndDate(dateObject);
  };

  const handleDataTypeChange = (e) => {
    setSelectedTypeHealthData(e.target.value)
  };

  if (loading) {
    return <Loader message="Preparando descarga" />
  }

  return (
    <FormMonitoring
      submitForm={handleExportObservations}
      resetFormInputs={resetFormInputs}
      isExport={true}
    >
      <SingleChoiceDropdown
        required
        label={Dashboard.TYPE_DATA}
        value={selectedTypeHealthData}
        items={dataTypeOptions}
        handleValue={handleDataTypeChange}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        <FormControl sx={{ mt: 2, mb: 1 }} className={classes.textFieldLabel}>
          <DatePickerMonitoring
            value={initialDate}
            maxDate={new Date()}
            setValue={handleInitialDate}
            label={Dashboard.INITIAL_DATE}
          />
        </FormControl>
        <FormControl sx={{ mt: 2, mb: 1 }} className={classes.textFieldLabel}>
          <DatePickerMonitoring
            value={endDate}
            maxDate={new Date()}
            minDate={initialDate}
            setValue={handleEndDate}
            label={Dashboard.END_DATE}
          />
        </FormControl>
      </Box>
      <Typography mt={1} variant='body' sx={{ color: "red" }}>
        {errorMessage}
      </Typography>
    </FormMonitoring>
  );
};

export default ExportForm;
